import React from 'react';
import { Shield, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="dark-content-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Shield className="footer-logo-icon" />
              <span className="footer-logo-text">Cyber-Wiz</span>
            </div>
            <p className="footer-description">
              Elevating cybersecurity postures with expert consulting, 
              advanced threat detection, and comprehensive security solutions.
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a href="/#services" className="footer-link">Vulnerability Management</a></li>
              <li><a href="/#services" className="footer-link">Risk Assessment</a></li>
              <li><a href="/#services" className="footer-link">Penetration Testing</a></li>
              <li><a href="/#services" className="footer-link">CMMC Readiness</a></li>
              <li><a href="/#services" className="footer-link">PCI DSS Audit</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><a href="/#contact" className="footer-link">Contact</a></li>
              <li><a href="#" className="footer-link">Privacy Policy</a></li>
              <li><a href="#" className="footer-link">Terms of Service</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Contact Info</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail size={16} />
                <span>support@cyber-wiz.com</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} />
                <span>+1 (765) 360-9775</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span>Nationwide Service</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Cyber-Wiz. All rights reserved. | Cybersecurity Wizardry at Your Service
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;